/* eslint-disable no-redeclare */
import { Map } from "immutable";
import { STATE_STATUS, INITIATE_CASE_STATE } from "constants";
import _groupBy from "lodash/groupBy";
import { CASE_NOTE_ACTIONS } from "constants/actions";
import { CaseNoteRecord } from "records/case-note-record";
import moment from "moment";

const INITIAL_STATE = new Map({});

export default (state = INITIAL_STATE, { type, payload }) => {
    switch (type) {
    case INITIATE_CASE_STATE:
        return state.set(
            payload.case_id,
            new Map({
                notes: new Map({}),
                status: STATE_STATUS.UNFETCHED,
                creating: false
            })
        );
    case CASE_NOTE_ACTIONS.FETCH_CASE_NOTES:
        return state.setIn(
            [payload.case_id, "status"],
            STATE_STATUS.FETCHING
        );
    case CASE_NOTE_ACTIONS.FETCHED_CASE_NOTES:
        // eslint-disable-next-line no-case-declarations
        let notes = payload.data.map(
            _ =>
                new CaseNoteRecord({
                    ..._,
                    create_date: moment(_.create_date),
                    create_date_string: moment(_.create_date).format("DD-MM-YYYY"),
                    state_status: STATE_STATUS.CREATED
                })
        );
        return state
            .setIn([payload.case_id, "status"], STATE_STATUS.FETCHED)
            .setIn(
                [payload.case_id, "notes"],
                new Map(_groupBy(notes, "create_date_string")).toOrderedMap().sort((a, b) => {
                    if(a[0].id > b[0].id) {
                        return -1;
                    }
                    if(a[0].id > b[0].id) {
                        return 1;
                    }
                    if(a[0].id === b[0].id) {
                        return 0;
                    }
                })
            );
    case CASE_NOTE_ACTIONS.FAILED_FETCH_CASE_NOTES:
        return state.setIn(
            [payload.case_id, "status"],
            STATE_STATUS.FETCH_FAILED
        );
    case CASE_NOTE_ACTIONS.CREATE_CASE_NOTE: {
        return state.updateIn([payload.case_id, "creating"], value => !value);
    }
    case CASE_NOTE_ACTIONS.CREATED_CASE_NOTE: {
        // eslint-disable-next-line no-case-declarations
        const current_date = moment();
        const current_date_string = current_date.format("DD-MM-YYYY");
        const note = new CaseNoteRecord({
            ...payload.note,
            is_active: true,
            create_date: current_date,
            create_date_string: current_date_string,
            state_status: STATE_STATUS.CREATED
        });

        return state.withMutations(mutator => {
            mutator = mutator
                .updateIn([payload.case_id, "creating"], () => false)
                .updateIn(
                    [payload.case_id, "notes"], 
                    notes => notes
                        .update(
                            current_date_string, 
                            item => {
                                if(item) {
                                    item.unshift(note);
                                    return item;
                                }
                                return [note];
                            }
                        )
                        .sortBy(
                            (v,k) => k, 
                            (a,b) => moment(a, "DD-MM-YYYY").isBefore(moment(b, "DD-MM-YYYY")) ? 1 : -1
                        )
                );
            return mutator;
        });
        
        
    }
    case CASE_NOTE_ACTIONS.FAILED_CREATE_CASE_NOTE:
        return state
            .updateIn(
                [payload.case_id, "creating"], false
            )
            .updateIn(
                [payload.case_id, "notes", payload.note_id],
                new CaseNoteRecord({
                    ...payload.note,
                    state_status: STATE_STATUS.CREATE_FAILED
                })
            );
    default:
        return state;
    }
};
